'use client';

import { useTranslations } from 'next-intl';
import { TrackedButton } from '@components/button';

/**
 * 쿠키 동의 배너를 다시 띄워 동의를 변경·철회할 수 있게 한다.
 *
 * 마케팅팀 요청 원안은 <a href="javascript:Cookiebot.renew()"> 였으나 button 으로 구현했다.
 * javascript: URL 은 CSP 에 걸리고, 이동하지 않는 동작을 링크로 노출하면 스크린리더가
 * "링크"로 읽어 WCAG 기준에 어긋난다. 동작(Cookiebot.renew())은 동일하다.
 */
export function CookieSettingsButton({ className }: { className?: string }) {
  const t = useTranslations('Footer');

  return (
    <TrackedButton
      type="button"
      label="company-link_cookie-settings"
      position="footer"
      className={className}
      onClick={() => window.Cookiebot?.renew?.()}
    >
      {t('cookie-settings')}
    </TrackedButton>
  );
}
